import axios from "axios";
import { received } from "../DocumentationReducer";
import { baseURL } from "../thunks";

export const deleteFolderSubscription =
  ({ id }) =>
  async (dispatch) => {
    try {
      const deleteReq = await axios({
        method: "delete",
        url: baseURL + "documentation/folders/" + id + "/subscription",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      return deleteReq;
    } catch (error) {
      console.log(error);
      dispatch(received({ error: true }));
    }
  };
